/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Subtext_Looking_Into_ItInputs */



/**
* | output |
* | --- |
* | "We're looking into it. Probably." |
*
* @param {Error_Subtext_Looking_Into_ItInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_subtext_looking_into_it = /** @type {((inputs?: Error_Subtext_Looking_Into_ItInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Subtext_Looking_Into_ItInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir kümmern uns darum. Wahrscheinlich.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous regardons ça. Sans doute.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("我们正在排查。大概吧。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("我們正在查。大概吧。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("확인하고 있습니다. 아마도요.")
	return /** @type {LocalizedString} */ ("We're looking into it. Probably.")
});